import { AppModule } from '@thoughtspot/blink-context';
import { SessionService } from '@thoughtspot/session-service';
import { shouldNotShowGlobalBanner } from './routes-util';

export const isLeftPanelVisible = (
    isOverlayPanel: boolean,
    isGlobalNavHidden: boolean,
    isInsightsPage: boolean,
    sessionService: SessionService,
    appModule?: AppModule,
) => {
    if (appModule === AppModule.Data && isGlobalNavHidden && !isOverlayPanel) {
        return true;
    }

    return (
        !isOverlayPanel &&
        !isGlobalNavHidden &&
        !(sessionService.hideHomepageLeftNav(true) && isInsightsPage)
    );
};

export const isGlobalBannerVisible = (
    pathname: string,
    isTrialVersionEnabled: boolean,
    isSlackBotEnabled: boolean,
    isServiceWorkerEnabled: boolean,
) => {
    return (
        !shouldNotShowGlobalBanner(pathname) &&
        (isTrialVersionEnabled || isSlackBotEnabled || isServiceWorkerEnabled)
    );
};
